const Domains: { [key: string]: string } = {
  ALDI: process.env.REACT_APP_ALDI || '',
  BLOOMS: process.env.REACT_APP_BLOOMS || '' ,
  MM: process.env.REACT_APP_MM || '',
  // ADMIN: process.env.REACT_APP_ADMIN || '',
  // SHOPPER: process.env.REACT_APP_SHOPPER || ''
};

export default Domains;
